module.exports = __webpack_public_path__ + "whatsapp-5ccd82d5fad0e6e87e64.svg";